import script from "./TopicForm.vue?vue&type=script&setup=true&lang=js"
export * from "./TopicForm.vue?vue&type=script&setup=true&lang=js"

import "./TopicForm.vue?vue&type=style&index=0&id=20309faf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20309faf"]])

export default __exports__